<div class="avaliacao-input-wrapper relative w-full flex flex-col">
  <ng-container *ngIf="nota; else notaVazia">
    <div *ngIf="deveOcultarNotaExame()" class="nota-exame-oculta">-</div>

    <ng-container *ngIf="!deveOcultarNotaExame()">
      <input
        *ngIf="isModoNumerico()"
        type="text"
        inputmode="decimal"
        class="form-control nota-input transition-colors"
        [value]="getNotaNumericaValue()"
        [attr.maxlength]="getMaxLengthNumerico()"
        [readonly]="isLeituraSomente()"
        [ngClass]="{
          'border-warning': nota.$$semNota && !nota.$$mensagemValidacao,
          '!border-red-500 focus:!ring-red-500 focus:!border-red-500': nota.$$mensagemValidacao
        }"
        (focus)="onNumericFocus()"
        (keydown)="onNumericKeyDown($event)"
        (input)="onInputChange($event)"
        (blur)="onBlur()"
      />

      <div *ngIf="isModoConceito()" class="nota-dropdown" (click)="onConceitoDropdownClick($event)">

        <div class="nota-dropdown__wrapper" style="position: relative; display: flex; align-items: center;">
          <button
            type="button"
            class="form-control nota-input nota-dropdown__trigger"
            [disabled]="isLeituraSomente()"
            (click)="toggleDropdown($event)"
            style="width: 100%; display: flex; align-items: center; justify-content: space-between; position: relative;"
          >
            <span class="nota-dropdown__value">{{ getConceitoPrimeiraLetraSelecionada() || ' ' }}</span>
            <span *ngIf="getConceitoPrimeiraLetraSelecionada() && !isLeituraSomente()" 
                  class="nota-dropdown__clear-btn"
                  style="display: inline-flex; align-items: center; justify-content: center; margin-left: 4px; margin-right: 12px; cursor: pointer;"
                  (click)="limparConceito($event); $event.stopPropagation();"
                  title="Limpar conceito"
                  aria-label="Limpar conceito selecionado">
              ×
            </span>
            <span class="nota-dropdown__arrow" aria-hidden="true" style="margin-left: 2px;">▾</span>
          </button>
        </div>

        <div *ngIf="conceitoDropdownAberto" class="nota-dropdown__menu">
          <button
            type="button"
            *ngFor="let conceito of getConceitoOptions(); let optionIndex = index"
            class="nota-dropdown__option"
            (click)="selecionarConceito(conceito, $event)"
          >
            {{ getConceitoOptionLabel(conceito, optionIndex) }}
          </button>
        </div>
      </div>

      <div *ngIf="isModoDescritivo()" class="nota-descritiva-shell flex justify-center w-full gap-1.5 mt-1.5">
        <button
          type="button"
          class="nota-descritiva-button nota-descritiva-indicator"
          [class.nota-descritiva-indicator--filled]="hasConteudoDescritivo()"
          [disabled]="isAcaoSecundariaDesabilitada()"
          (click)="onClickAvaliacaoDescritiva()"
          aria-label="Abrir avaliação descritiva"
          title="{{ hasConteudoDescritivo() ? 'Editar avaliação descritiva' : 'Adicionar avaliação descritiva' }}"
        >
          <lucide-icon name="notebook-pen" class="w-4 h-4"></lucide-icon>
          <span *ngIf="hasConteudoDescritivo()" class="nota-descritiva-indicator__check">
            <lucide-icon name="check" class="w-2.5 h-2.5"></lucide-icon>
          </span>
        </button>
        <button
          type="button"
          class="nota-descritiva-button nota-descritiva-indicator"
          [class.nota-descritiva-indicator--filled]="hasConteudoParecer()"
          [disabled]="isAcaoSecundariaDesabilitada()"
          (click)="onClickParecer()"
          aria-label="Abrir parecer"
          title="Parecer"
        >
          <lucide-icon name="message-square" class="w-4 h-4"></lucide-icon>
          <span *ngIf="hasConteudoParecer()" class="nota-descritiva-indicator__check">
            <lucide-icon name="check" class="w-2.5 h-2.5"></lucide-icon>
          </span>
        </button>
      </div>
    </ng-container>

    <div class="avaliacao-actions flex justify-center w-full gap-1.5 mt-1.5">
      <button
        type="button"
        class="nota-descritiva-button nota-descritiva-indicator"
        [class.nota-descritiva-indicator--filled]="hasConteudoParecer()"
        *ngIf="podeMostrarParecer()"
        [disabled]="isAcaoSecundariaDesabilitada()"
        (click)="onClickParecer()"
        aria-label="Abrir parecer"
        title="{{ hasConteudoParecer() ? 'Editar parecer' : 'Adicionar parecer' }}"
      >
        <lucide-icon name="message-square" class="w-4 h-4"></lucide-icon>
        <span *ngIf="hasConteudoParecer()" class="nota-descritiva-indicator__check">
          <lucide-icon name="check" class="w-2.5 h-2.5"></lucide-icon>
        </span>
      </button>
      <button
        class="btn-icon btn-icon-sm text-success"
        *ngIf="podeMostrarCha()"
        [disabled]="isAcaoSecundariaDesabilitada()"
        (click)="onClickCha()"
        title="CHA"
      >
        <lucide-icon name="star" class="w-4 h-4"></lucide-icon>
      </button>
    </div>
  </ng-container>

  <ng-template #notaVazia>
    <input type="text" inputmode="decimal" class="form-control nota-input" value="" [readonly]="disabled" />
  </ng-template>
</div>
